"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const helper_1 = require("./helper");
class PayloadMutator {
    mutatePayload(events) {
        const batch_id = (0, uuid_1.v1)();
        const sent_at = (0, helper_1.utcTimestamp)(new Date());
        events = events.map((event) => {
            return Object.assign(Object.assign({}, Object.fromEntries(Object.entries(event).filter(([_, v]) => v !== null))), { batch_id,
                sent_at });
        });
        return JSON.stringify(events, (key, value) => {
            if (typeof value === 'boolean' || typeof value === 'number') {
                return value.toString();
            }
            return value;
        });
    }
}
exports.default = PayloadMutator;
